module.exports = __webpack_public_path__ + "static/palmas-af2806ad96d4319418ef654fc411fa8d.png";